import shiftImage from './images/shift.png';
import spaceImage from './images/space.png';
import backspaceImage from './images/back-space.png';

export enum TabType {
  LETTERS = 'letters',
  SYMBOLS = 'symbols'
}

export enum KeyName {
  SYMBOLS = 'symbols',
  UPPER_CASE_LETTER = 'upperCase',
  LOWER_CASE_LETTERS = 'lowerCase'
}

export const SHIFT = 'SHIFT';

export const LOWER_CASE_KEYS = [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ñ'],
  [SHIFT, 'z', 'x', 'c', 'v', 'b', 'n', 'm', '@'],
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
];

export const UPPER_CASE_KEYS = LOWER_CASE_KEYS.map(keys =>
  keys.map(key => (typeof key === 'string' ? key.toUpperCase() : key))
);

export const SYMBOL_KEYS = [
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  ['/', ':', ';', '(', ')', '$', '&', '@', '"', ','],
  ['¿', '?', '¡', '!', '\'', '[', ']', '{', '}', '#'],
  ['%', '^', '*', '=', '\\', '|', '~', '<', '>', '>'],
];

export const DIGITS_KEYS = [
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
];

export const SPACE = 'space';
export const GUION = '_';
export const CONTEXT_KEYS_STRING: string = '{"default":[[".com",".net","@gmail.com","@hotmail.com","@prodigy.net"]],"mexico":[[".com",".mx","@infinitummail.com","@gmail.com","@yahoo.com"]],"argentina":[[".com",".ar","@outlook.com","@gmail.com","@hotmail.com"]]}';

export const CONTEXT_KEYS :  Map<string, any> =   new Map<string, any>();
CONTEXT_KEYS.set("default", [['.com', '.net', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("argentina", [['.com', '.ar', '@outlook.com', '@gmail.com', '@hotmail.com']]);
CONTEXT_KEYS.set("brasil", [['.com', '.br', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("chile", [['.com', '.cl', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("colombia", [['.com', '.co', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("dominicana",[['.com', '.do', '@gmail.com', '@hotmail.com', '@prodigy.net']] );
CONTEXT_KEYS.set("ecuador", [['.com', '.ec', '@gmail.com', '@hotmail.com', '@prodigy.net']] );
CONTEXT_KEYS.set("elsalvador", [['.com', '.sv', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("guatemala", [['.com', '.gt', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("honduras", [['.com', '.hn', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("mexico", [['.com', '.mx', '@infinitummail.com', '@gmail.com', '@yahoo.com']]);
CONTEXT_KEYS.set("nicaragua", [['.com', '.ni', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("panama", [['.com', '.pa', '@gmail.com', '@hotmail.com', '@prodigy.net']] );
CONTEXT_KEYS.set("paraguay", [['.com', '.py', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("peru", [['.com', '.pe', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("uruguay", [['.com', '.uy', '@gmail.com', '@hotmail.com', '@prodigy.net']]);
CONTEXT_KEYS.set("costarica", [['.com', '.cr', '@gmail.com', '@hotmail.com', '@prodigy.net']]);


export const FIXED_KEYS = [
  ['_', '-', SPACE, '.', '+']
];

export const Images: Record<string, string> = {
  shift: shiftImage,
  space: spaceImage,
  backSpace: backspaceImage
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Keyboard/constants.ts